/*
    Component that displays x number of items from the list
    and then displays + next to it to expand to full list
    and - to collapse the expanded list

    props : list

    count : number
*/
import React, { useState, useEffect, useCallback } from 'react';

const DisplayListShortner = ({ count = 5, list, separator = ', ' }) => {
   const [displayList, setDisplayList] = useState([]);

   const displayMore = useCallback((e) => {
      setDisplayList([...list.slice(0, list.length)]);
      e.preventDefault();
   });

   const displayLess = useCallback((e) => {
      setDisplayList([...list.slice(0, count < list.length ? count : list.length)]);
      e.preventDefault();
   });

   useEffect(() => {
      setDisplayList([...list.slice(0, count < list.length ? count : list.length)]);
   }, [count, list]);

   return (
      <>
         {displayList.map((item, index) => (
            item + (index < (displayList.length - 1) ? separator : '')
         ))}
         {list.length > count
                && (
                   <>
                      {displayList.length !== list.length && <a className='btn-link text-dark-blue ml-2' onClick={displayMore} title='Show more' ><i className='fas fa-plus' /></a>}
                      {displayList.length === list.length && <a className='btn-link text-dark-blue ml-2' onClick={displayLess} title='Show less'><i className='fas fa-minus' /></a>}
                   </>
                )}
      </>
   );
};

export default DisplayListShortner;
